<script setup lang="ts">
    import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { CheckboxGroupRoot } from 'reka-ui';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    interface Props {
        columnId: string;
        options: { value: string | number; label: string }[];
        modelValue: (string | number)[];
        title?: string;
    }

    const props = defineProps<Props>();

    const { t } = useI18n();

    const emit = defineEmits<{
        'update:modelValue': [value: (string | number)[]];
    }>();

    const value = computed({
        get: () => props.modelValue,
        set: (newValue) => emit('update:modelValue', newValue),
    });
</script>

<template>
    <CheckboxGroupRoot
        v-model="value"
        class="space-y-2"
    >
        <Label
            v-for="option in options"
            :key="option.value"
            class="flex items-center gap-2 text-xs"
        >
            <Checkbox :value="option.value" />
            <span>{{ option.label }}</span>
        </Label>
    </CheckboxGroupRoot>
    <span
        v-if="!options.length"
        class="text-muted-foreground text-xs"
    >
        {{ t('forms.no_options') }}
    </span>
</template>
